import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-email-verify-page',
  templateUrl: './email-verify-page.component.html',
  styleUrls: ['./email-verify-page.component.scss']
})
export class EmailVerifyPageComponent implements OnInit {

  constructor(private route: ActivatedRoute) { }
  email: string;
  transparent: boolean;

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.email = params['email'];
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/onboarding/components/email-verify-page/email-verify-page.component.ts